import { render, staticRenderFns } from "./shopVideo.vue?vue&type=template&id=a9ae7256&scoped=true"
import script from "./shopVideo.vue?vue&type=script&lang=js"
export * from "./shopVideo.vue?vue&type=script&lang=js"
import style0 from "./shopVideo.vue?vue&type=style&index=0&id=a9ae7256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ae7256",
  null
  
)

export default component.exports